/* eslint-disable eqeqeq */
import * as Sentry from "@sentry/react";
import Types from "./types";
import { ListingServiceAU as ListingService, ListingServiceAU, ListingServiceAUV2 } from "../../../service";
// import categoryJson from "../../../utils/category.json";
import { getSanitizedFilterData } from "../../../utils/helpers/category-helper";
import { AU_RECENTLY_VIEWD_TIMESTAMP, LISTING_TYPE, API_SOURCE } from "../../../constants/app-constants";
// import staticJson from "../../../config/au.mobile/car-list.json";
import { API_VERSION_V2 } from "../../../service/api-version";
import { CASED_EXPERMIMENT_TYPE } from "../../../constants/optimize-constants";
import { getRecentViewedWithTimestamp } from "../../../utils/helpers/recently-viewed";
import { STATE_CODES } from "../../../constants/state-name-constants";
import getMeaningfulExperimentNames from "../../../utils/statsig-ab-utils/get-meaningful-experiment-names";
import { STATE_EXPERIMENT_MAP } from "../../../../server/utils/get-listing-sorting-experiment-data";

const fetchFiltersInit = () => ({
    type: Types.FETCH_FILTERS
});

const fetchFilterSuccess = (data) => ({
    type: Types.FETCH_FILTERS_SUCCESS,
    data
});

const fetchFiltersFailure = () => ({
    type: Types.FETCH_FILTERS_FAILURE
});

const fetchFilters = (apiVersion, sortingVariant) => (dispatch, getState) => {
    dispatch(fetchFiltersInit());
    if (sortingVariant == null) {
        Sentry.metrics.count("sorting.variant.null", 1, {
            attributes: { function_name: "fetchFilters", platform: "desktop" }
        });
    }

    const { user: { secureToken, userGeoData = {}}, abExperiment: {webPriceDropDesktop, webLocationHighlighting, webCarTour} } = getState();

    const {data: webPriceDropDesktopVariant} = webPriceDropDesktop || {};
    const {data: webLocationHighlightingVariant} = webLocationHighlighting || {};
    const {data: webCarTourVariant} = webCarTour || {};

    let queryParams = webPriceDropDesktopVariant ? `experimentVariant=${CASED_EXPERMIMENT_TYPE[webPriceDropDesktopVariant]}` : "";
    queryParams = webLocationHighlightingVariant ? `${queryParams}&highlightLocationVariant=highlighting__${CASED_EXPERMIMENT_TYPE[webLocationHighlightingVariant]}` : queryParams;
    queryParams = webCarTourVariant ? `${queryParams}&videoTourVariant=${CASED_EXPERMIMENT_TYPE[webCarTourVariant]}` : queryParams;

    let listingFiltersApi =  ListingService.fetchFilters;
    switch (apiVersion) {
    case API_VERSION_V2:
        listingFiltersApi =  ListingServiceAUV2.fetchFiltersV2;
        break;
    default:
        listingFiltersApi = listingFiltersApi;
    }
    return listingFiltersApi({ token: secureToken, userGeoData, queryParams, sortingVariant })
        .then((response) => {
            dispatch(fetchFilterSuccess(response.data));
            return Promise.resolve(response.data);
        })
        .catch(() => {
            dispatch(fetchFiltersFailure());
            return Promise.reject();
        });
};

const updateSSRStatus = (isSSR) => ({
    type: Types.UPDATE_SSR_STATUS,
    isSSR
});

const updateFilterTimestamp = (lastUpdated) => ({
    type: Types.UPDATE_FILTER_TIMESTAMP,
    lastUpdated
});

const updateSelectedOnScreenFilter = (selectedOnScreenFilter) => ({
    type: Types.UPDATE_SELECTED_ON_SCREEN_FILTER,
    selectedOnScreenFilter
});

const updatePriceFilterType = (priceFilterType) => ({
    type: Types.UPDATE_SELECTED_ON_SCREEN_FILTER,
    priceFilterType
});

const updateFilterOptionData = (data) => ({
    type: Types.UPDATE_FILTER_OPTION_DATA,
    data
});

const updateAllFiltersVisibility = (showAllFilters) => ({
    type: Types.UPDATE_ALL_FILTERS_VISIBILITY,
    showAllFilters
});

const fetchListingCountInit = () => ({
    type: Types.FETCH_LISTING_COUNT
});

const fetchListingCountSuccess = (data) => ({
    type: Types.FETCH_LISTING_COUNT_SUCCESS,
    data
});

const fetchListingCountFailure = () => ({
    type: Types.FETCH_LISTING_COUNT_FAILURE
});

const fetchListingCount = (params, queryString) => (dispatch, getState) => {
    dispatch(fetchListingCountInit());
    const { user: { secureToken, userGeoData = {} }, abExperiment = {} } = getState();

    // Get sortingVariant from AB experiment
    const {state: {isoCode = STATE_CODES.VIC} = {}} = userGeoData || {};
    const experimentKey = STATE_EXPERIMENT_MAP[isoCode || STATE_CODES.VIC]?.[API_SOURCE.WEB_APP];
    const sortingReducerKey = getMeaningfulExperimentNames(experimentKey);
    const { [sortingReducerKey]: {data: sortingVariant} = {}} = abExperiment || {};

    if (sortingVariant == null) {
        Sentry.metrics.count("sorting.variant.null", 1, {
            attributes: { function_name: "fetchListingCount", platform: "desktop" }
        });
    }

    ListingService.fetchListing(params, queryString, secureToken, userGeoData, sortingVariant)
        .then((response) => {
            dispatch(fetchListingCountSuccess(response.data));
        })
        .catch(() => {
            dispatch(fetchListingCountFailure());
        });
};

const updateFilterTabType = (activeFilterTab) => ({
    type: Types.UPDATE_FILTER_TAB_TYPE,
    activeFilterTab
});

const updateSelectedSort = (selectedSort) => ({
    type: Types.UPDATE_SELECTED_SORT,
    selectedSort
});

const clearAllFilters = () => ({
    type: Types.CLEAR_ALL_FILTERS
});

const updateAppliedFilters = (appliedFilters) => ({
    type: Types.UPDATE_APPLIED_FILTERS,
    appliedFilters
});

const updateAppliedSuggestions = () => ({
    type: Types.UPDATE_APPLIED_SUGGESTIONS
});

const updateSelectedSuggestions = (data) => ({
    type: Types.UPDATE_SELECTED_SUGGESTIONS,
    data
});

const updateUrlOptions = (urlOptions) => ({
    type: Types.UPDATE_URL_OPTIONS,
    urlOptions
});

const clearSuggestions = (filterKey) => ({
    type: Types.CLEAR_SUGGESTIONS,
    filterKey
});

const updateAllSubFilterOptions = ({filterKey, optionKey, isSelected, isAllModelVariant = false}) => ({
    type: Types.UPDATE_ALL_SUB_FILTER_OPTIONS,
    filterKey,
    optionKey,
    isSelected,
    isAllModelVariant
});

const updateSortModalVisibility = (isVisible) => ({
    type: Types.UPDATE_SORT_MODAL_VISIBILITY,
    isVisible
});

const fetchCategoryFilterInit = () => ({
    type: Types.FETCH_CATEGORY_FILTER_INIT,
    categoryLoading: true
});

const fetchCategoryFiltersSuccess = (data) => ({
    type: Types.FETCH_CATEGORY_FILTER_SUCCESS,
    data
});

const fetchCategoryFiltersFailure = () => ({
    type: Types.FETCH_CATEGORY_FILTER_FAILURE,
    data: true
});

const updateAllSelectedFilterOptions = (data) => ({
    type: Types.UPDATE_ALL_SELECTED_FILTER_OPTIONS,
    data
});

const updateSelectedCategories = (data) => ({
    type: Types.UPDATE_SELECTED_CATEGORIES,
    data
});

const fetchCategoryFilters = () => (dispatch) => {
    dispatch(fetchCategoryFilterInit());
    ListingService.fetchCategories()
        .then((response) => {
            const { categoryFilterDetails } = response.data;
            const sanitizedCategory = getSanitizedFilterData(categoryFilterDetails);
            dispatch(fetchCategoryFiltersSuccess(sanitizedCategory));
        })
        .catch(() => {
            dispatch(fetchCategoryFiltersFailure());
        });
};

const setMarketingCategory = (data) => ({
    type: Types.SET_MARKETING_CATEGORY,
    data
});

const updateListingType = (listingType = LISTING_TYPE.ALL_CARS) => ({
    type: Types.UPDATE_LISTING_TYPE,
    listingType
});

const setListingFBEvents = (fbEventType) => ({
    type: Types.SET_LISTING_FB_EVENTS,
    fbEventType
});

const clearSelectedFilter = (data) => ({
    type: Types.CLEAR_SELECTED_FILTER,
    data
});

const replaceSelectedFilter = (data) => ({
    type: Types.REPLACE_SELECTED_FILTERS,
    data
});
const setRecentlyViewedData = (secureToken) => async () => {
    const recentlyViewedPayload = getRecentViewedWithTimestamp(AU_RECENTLY_VIEWD_TIMESTAMP) || {};
    const payload = {
        appointmentIds: recentlyViewedPayload
    };
    return ListingServiceAU.setRecentlyViewed(payload || {}, secureToken)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch(() => {
            return Promise.reject();
        });
};
export {
    fetchFilters,
    updateSSRStatus,
    updateFilterTimestamp,
    updateSelectedOnScreenFilter,
    updatePriceFilterType,
    updateFilterOptionData,
    updateAllFiltersVisibility,
    fetchListingCount,
    updateFilterTabType,
    updateSelectedSort,
    clearAllFilters,
    updateAppliedFilters,
    updateUrlOptions,
    updateAppliedSuggestions,
    updateSelectedSuggestions,
    clearSuggestions,
    updateAllSubFilterOptions,
    updateSortModalVisibility,
    fetchCategoryFilters,
    updateAllSelectedFilterOptions,
    updateSelectedCategories,
    setMarketingCategory,
    updateListingType,
    setListingFBEvents,
    clearSelectedFilter,
    replaceSelectedFilter,
    setRecentlyViewedData
};
